import styled from 'styled-components';
import ndsTokens from 'nicollet-tokens';
import { buttonTertiaryStyles, buttonTertiaryHoverStyles, buttonTertiaryActiveStyles } from '@nicollet/common';
export { buttonTertiaryActiveStyles, buttonTertiaryHoverStyles, buttonTertiaryStyles } from '@nicollet/common';
import { BaseButton } from '../BaseButton/index.js';

const setSize = ({
  size = 'md'
}) => {
  switch (size) {
    case 'sm':
      return `
        font-size: ${ndsTokens.font.size.text.small};
      `;

    case 'md':
      return `
        font-size: ${ndsTokens.font.size.text.medium};
        `;

    case 'lg':
      return `
        font-size: ${ndsTokens.font.size.text.base};
      `;

    default:
      return `
          font-size: ${ndsTokens.font.size.text.medium};
        `;
  }
};

const ButtonTertiary = styled(BaseButton)`
  ${buttonTertiaryStyles}
  ${setSize};

  &:hover {
    ${buttonTertiaryHoverStyles}
  }

  &:active {
    ${buttonTertiaryActiveStyles}
  }

  &:disabled {
    ${buttonTertiaryStyles};

    &:hover {
      ${buttonTertiaryStyles};
    }
  }
`;

export { ButtonTertiary };
